// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"d58bc09d","667":"3798eca9","977":"70c41ee3"}[chunkId] + ".chunk.js";
};